import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import logo from '../../assets/white-atw.png';

import Parallax from '../layout/Parallax';
import { Group, PlayCircleFilled } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        }
    },
    overline: {
        [theme.breakpoints.up('xs')]: {
            fontSize: theme.typography.h5.fontSize

        },
        [theme.breakpoints.up('sm')]: {
            fontSize: theme.typography.h4.fontSize
        },
    },
    nanoMeet: {
        fontWeight: 700
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            height: 200

        },
        [theme.breakpoints.up('sm')]: {
            height: 300

        },
    },
    textWrapper: {
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(2),
            textAlign: 'center'
        },
        [theme.breakpoints.up('md')]: {
            marginTop: 0,
            marginLeft: theme.spacing(4),
            textAlign: 'left'

        }
    },
    text: {
        color: theme.palette.common.white,
        fontWeight: 300
    },
    buttonWrapper: {
        marginTop: theme.spacing(1)
    },
    button: {
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(1),
            '&:first-of-type': {
                marginRight: theme.spacing(0.5)
            }

        },
        [theme.breakpoints.up('md')]: {
            '&:first-of-type': {
                marginRight: theme.spacing(1.5)
            }
        },
    }
}))

export default function Intro(props) {
    const classes = useStyles();

    return (
        <Parallax header>
            <div className={classes.root}>
                <div className={classes.logoWrapper}>
                    <img className={classes.logo} src={logo} />
                </div>
                <div className={classes.textWrapper}>
                    <Typography variant="h4" className={clsx(classes.text, classes.overline)}>
                        <b className={classes.nanoMeet}>nanoMeet</b> &amp; <b className={classes.nanoMeet}>nanoStream Cloud</b><br />the ultra-low latency live streaming platform for<br />meetings and events running under your own brand!
                    </Typography>
                    <div className={classes.buttonWrapper}>
                        <Button
                            className={classes.button}
                            color="secondary"
                            size="large"
                            variant="contained"
                            onClick={props.clickedGettingStarted}
                        >
                            Getting Started
                        </Button>
                        <Button
                            className={classes.button}
                            color="secondary"
                            size="large"
                            variant="outlined"
                            startIcon={<Group />}
                            onClick={props.clickedDemo}
                        >
                            Personal Demo
                        </Button>
                    </div>
                </div>
            </div>
        </Parallax>
    )
}